import z from 'zod'

const loginSchema = z.object({
  email: z.email(),
  password: z.string(),
})

export type LoginSchema = z.infer<typeof loginSchema>

export default loginSchema
